module.exports = __webpack_public_path__ + "img/pixels.04f88282.jpg";